import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { Common } from 'src/app/common';
import { Utility } from 'src/app/core/common';
import { ActivityService } from 'src/app/services/activity.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'activity-detail',
  templateUrl: './activity-detail.component.html',
  styleUrls: ['./activity-detail.component.scss']
})
export class ActivityDetailComponent implements OnInit {
  Utility = Utility;
  Common = Common;

  constructor(private store: Store, private activityService: ActivityService,
    private userService: UserService, private spinner: SpinnerService) { }

  @Input() activity: any;
  @Input() saveMode: string;
  @Input() isNext: boolean;
  @Output() saved = new EventEmitter<boolean>();
  operators: any[];
  current: any;
  isAdmin: boolean;
  isKarpasha: boolean;
  addAnother: boolean;
  edit: any = {};
  @Input() type: string;
  @Input() data: any;

  get isNew() { return !this.activity?.Id; }
  get isCreator() { return this.isAdmin || this.activity.CreatorId == this.current.Id; }
  get isOperator() { return this.isAdmin || this.activity.OperatorId == this.current.Id; }

  async ngOnInit() {
    this.current = this.store.selectSnapshot(state => state.auth.user);
    this.isAdmin = this.current?.Operator?.Disabled === false;
    this.isKarpasha = this.current?.Karpasha?.Disabled === false;

    this.operators = [this.current];
    if (this.isAdmin || this.isKarpasha)
      this.userService.karpashas$.subscribe(_ => this.operators = _);

    this.setEdit();

    if (this.type) this.activity.Activity_Type = this.type;
    if (this.data) this.activity.Data = this.data;
  }

  private setEdit() {
    this.edit = {
      Note: this.isNew || (this.isCreator && !this.isOperator),
      Operator: this.isNew,
      DueDate: this.isNew,
    };
  }

  async save(setDone?: boolean) {
    this.spinner.show('loading');
    if (setDone) this.activity.IsDone = true;

    this.activity = await this.activityService.save(this.activity);
    this.saved.emit(!this.addAnother);

    if (this.addAnother) {
      var operator = this.activity.Operator || this.current;
      var operatorId = operator.id || operator.Id;

      this.activity = {
        Activity_Type: this.activity.Activity_Type,
        Key: this.activity.Key,
        UserId: this.activity.UserId || undefined,
        JobId: this.activity.JobId || undefined,
        OperatorId: operatorId,
        Operator: operator,
        IsDone: false,
      };
      this.setEdit();
      delete this.addAnother;
    }
    this.spinner.hide('loading');

  }

  async remove() {
    this.spinner.show('loading');
    this.activity.IsDeleted = true;
    this.activity = await this.activityService.save(this.activity);
    this.saved.emit(true);
    this.spinner.hide('loading');
  }
}
